import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/convocationCertificatePrintRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';
function ConvocationCertificate({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');
  const [name,setName]=useState('');
  const [ename,setEName]=useState('');
  const [error,setError]=useState('');
  const [oldName,setOldName]=useState('');
  const [isDownloading,setIsDownloading]=useState(false);
const[searching,setSearching]=useState(false);
  const [status,setStatus]=useState('');
  const [studentObject,setStudentObject]=useState(null);
  
const[id,setId]=useState('');


const [activeTab, setActiveTab] = useState("waiting");
  const [list, setList] = useState(["1","2"]);
  const [loading, setLoading] = useState(false);

  // Fetch list when tab changes
   const fetchData = async () => {
      setLoading(true);
      try{
            const response= await editapi.post('/loadList',{ activeTab},{headers:{'Authorization':`Bearer ${accessToken}`}});    
               setList(response.data.list);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/loadList',{ activeTab},{headers:{'Authorization':`Bearer ${nat}`}});    
                            setList(response.data.list);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          } finally {
        setLoading(false);
      }
    };
  useEffect(() => {
   

    fetchData();
  }, [activeTab]);

  const handleGoBack = () => {
    navigate(`/`); 
  };



const handleRollnoChange = (e) => {
    setRollno(e.target.value);
    setName('');
    setEName('');
    setError('');
    setOldName('');
    setId('');
    setStatus('');setStudentObject(null);
  };

const setStudent=(student)=>
{
    if(student)
    {
    setName(student.assamese_name);
     setEName(student.name);
    setId(student._id);
    setOldName(student.assamese_name);
    setStatus(student.status||"new");
     setError("");
     setStudentObject(student);
    }
    else{
setName('');
 setEName('');
    setId('');
      setOldName('');
    setError("Student not found!");
     setStatus('');
     setStudentObject(null);
    }
}

    
    async function handleSearch(rollno)
        {
          //e.preventDefault();
          setSearching(true);
          setStudent(null);
          try{
            const response= await editapi.post('/findConvoStudent',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
               setStudent(response.data.studentDetails);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/findConvoStudent',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                           setStudent(response.data.studentDetails);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            setSearching(false);
          }
        }
  
 async function handleSave(e)
        {
          e.preventDefault();
          try{
            const response= await editapi.post('/updateConvoStudentName',{ rollno,id,name:name,ename},{headers:{'Authorization':`Bearer ${accessToken}`}});    
               setStudent(response.data.studentDetails);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/updateConvoStudentName',{ rollno,id,name:name,ename},{headers:{'Authorization':`Bearer ${nat}`}});    
                           setStudent(response.data.studentDetails);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }

async function printCertificate(){}


 function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }
  async function handleDownloadGradeCards(e,bg)
    {
      e.preventDefault();
      setIsDownloading(true);
      try{
        //session, batch, semester,bg
        const response= await editapi.post('/printConvoCertificate',{rollno,id,bg:'NO'},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await editapi.post('/printConvoCertificate',{rollno,id,bg:'NO'},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
      finally
      {
        setIsDownloading(false);
      }
    }

 async function handleRequestPermission(e)
    {
      e.preventDefault();
      setIsDownloading(true);
      try{
        //session, batch, semester,bg
        const response= await editapi.post('/requestPermission',{rollno,id},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      setStudent(response.data.studentDetails);
      await fetchData();
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await editapi.post('/requestPermission',{rollno,id},{headers:{'Authorization':`Bearer ${nat}`}});    
            setStudent(response.data.studentDetails);await fetchData();
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
      finally
      {
        setIsDownloading(false);
      }
    }
const handleItemClick = async (item) => {
  setRollno(item.enrolment_id);
  setName('');
    setEName('');
    setError('');
    setOldName('');
    setId('');
    setStatus('');setStudentObject(null);
  await handleSearch(item.enrolment_id);
};
  return (
     <main className="w-full  ">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> CONVOCATION CERTIFICATE</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

 <div className="flex w-full h-[72vh]">
  {/* Left Panel - 30% */}
<div className="w-[30%] p-4 bg-blue-200 flex flex-col items-center">
      {/* Tabs */}
      <div className="w-full flex justify-around border-b border-gray-300 pb-2 mb-2">
        {["waiting", "accepted", "declined"].map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 text-sm font-medium ${
              activeTab === tab
                ? "border-b-2 border-blue-600"
                : "hover:border-b-2 hover:border-blue-400"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Scrollable Content */}
      <div className="w-full flex-1 overflow-y-auto max-h-[calc(100vh-100px)]">
        <div className="space-y-4 px-2">
          {loading ? (
            <p className="text-center text-gray-600">Loading...</p>
          ) : list.length === 0 ? (
            <p className="text-center text-gray-600">No records found.</p>
          ) : (
            list.map((item, i) => (
             <div
                key={i}
                className="p-2 rounded text-center shadow-sm bg-gray-100 hover:bg-red-400 hover:text-white cursor-pointer transition-all duration-200"

                onClick={() => handleItemClick(item)}
              >
                {item.name} ({item.enrolment_id})
              </div>
            ))
          )}
        </div>
      </div>
    </div>


      <div className="w-[70%]  flex flex-col items-center gap-4 ">
       
        
        

        <div className="w-full flex items-center justify-center mt-4">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={(e)=>handleSearch(rollno)}>
                SEARCH
              </button>

                </div>
        </div>

        {id!='' && (<div className="flex flex-col justify-center items-center p-1 mt-2 w-[600px]">
            <label className="text-gray-400">
                CONVOCATION
            </label>            
            <p>{studentObject.convocation_number},{studentObject.convocation_year}</p>
<label className="mt-2 text-gray-400">
                Stream
            </label>            
            <p>{studentObject.stream_name}</p>

            <label className="text-gray-400 mt-4">
                Name
            </label>            
          
             <input
            value={ename}
            onChange={(e)=>setEName(e.target.value)}
            onBlur={handleSave}
             className="w-full border-b border-gray-300 outline-none focus:border-green-600 px-2 py-1"
            />

          
            <label className="mt-4 text-gray-400">
                Assamese Name
            </label>
            <input
            value={name}
            onChange={(e)=>setName(e.target.value)}
            onBlur={handleSave}
             className="w-full border-b border-gray-300 outline-none focus:border-green-600 px-2 py-1"
            />

           <div className="w-full  p-1 flex justify-end mt-3">
  {false && (<button
    className={`bg-blue-500 text-xs text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all duration-300 
                hover:bg-blue-600 hover:scale-105 active:scale-95 
                ${oldName === name ? 'opacity-50 cursor-not-allowed' : ''}`}
    onClick={handleSave}
    disabled={oldName === name}
  >
    UPDATE
  </button>)}

  {status === "accepted" && (
  <button
    className={`bg-green-500 text-xs text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all duration-300 
                hover:bg-green-600 hover:scale-105 active:scale-95`}
    onClick={(e) => handleDownloadGradeCards(e, "yes")}
  >
    DOWNLOAD CERTIFICATE
  </button>
)}

{(status === "new" || status === "declined" || status === "") && (
  <button
    className={`bg-yellow-500 text-xs text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all duration-300 
                hover:bg-yellow-600 hover:scale-105 active:scale-95`}
    onClick={(e) => handleRequestPermission(e)}
  >
    REQUEST PERMISSION
  </button>
)}

{status === "waiting" && (
  <p className="w-full text-gray-400">
    A request is sent to admin on{" "}
    <span className="text-blue-500">
      {new Date(studentObject.requested_on).toDateString()}
    </span>{" "}
    for approval. You will be able to download the certificate once admin approves the request.
  </p>
)}


</div>
        </div>)}
        {!searching && <p>{error}</p>}
        {searching && <p>Searching......</p>}


      </div>

    </div>

      
      </div>
    </main>
  );
}

export default ConvocationCertificate;
